import React, {  Component } from 'react'
import { connect } from 'react-redux'

import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'

import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Colors from 'material-ui/styles/colors'

import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'

import AutoComplete from 'material-ui/AutoComplete'
import DatePicker from 'material-ui/DatePicker'
import TextField from 'material-ui/TextField'
import Slider from 'material-ui/Slider'
import DropDownMenu from 'material-ui/DropDownMenu'
import Checkbox from 'material-ui/Checkbox'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'

import { ownerProperties } from 'selectors/owner'

let select = (state, props) => ({
	ownerProperties: ownerProperties(state, props.id)
})
export class OwnerCard extends Component{
	render(){
		let { props } = this
		return(
			(!props.owner)? <div></div>
				:<Link
					to={`/manager/owners/${props.id}`}
					style={{textDecoration: "none", color: "#FFF"}}
				>
				<ListItem
					key={`task-${props.id}`}
					style={{
						height: "86px"
					  , backgroundColor: (props.lastInteracted == props.id)? "#E8E8E8": "#FFF"
					  , overflow: 'hidden'
					  , paddingLeft:"0px"
					  , marginLeft: "0px"
					  , borderBottom: "1px solid #e1e3e2"
					  , margin: "0"
					  , textOverflow: "ellipsis"
					}}

					onClick={(evt)=> {
						props.openPanel({type: 'owner', id: props.id})
					}}
				>
					<div
						style={{
							marginTop: "16px",
							float: "left",
							marginRight: "22px",
							marginLeft: "8px",
							color: "#000",
							fontSize: "20px",
							fontWeight: "bold"
						}}
					>
							{
								(props.ownerProperties)?
								props.ownerProperties.length:"0"
							}

					</div>
					<div
						style={{
							width: "70%"
						  , display: "inline-block"
						  , verticalAlign: "bottom"
						  , textOverflow: "ellipsis"
						}}
					>
						{(props.owner.ownerType=="business")?<span><span style={{fontWeight: "bold"}}>{props.owner.firstName}</span> ({props.owner.contactName})</span>:<span style={{fontWeight: "bold"}}>{props.owner.firstName}</span>}
					</div>
					<div>
						<p
							style={{
								position: "relative"
							  , maxWidth: "95%"
							  , fontSize: "14px"
							  , marginTop: "2px"
							  , marginLeft: "6px"
							  , marginBottom: "0px"
							  , textOverflow: "ellipsis"
							  , whiteSpace: "nowrap"
							  , overflow: "hidden"
							}}
						>
							<span style={{fontWeight: "bold"}}>Phone: </span>{(props.owner.phoneNumber)? props.owner.phoneNumber : 'No number'}
							<br />
							<span style={{fontWeight: "bold"}}>Email: </span>{(props.owner.email)? props.owner.email : 'No e-mail'}
							<br/>
						</p>
					</div>
				</ListItem>
			</Link>
		)
	}
}
export default connect(select)(OwnerCard)



// WEBPACK FOOTER //
// ./src/routes/manager/owners/OwnerCard.js